<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>

  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">User Management</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>
  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :items="confirmedUsers ? allUsers.filter(a => a.CheckerID !== 0 && a.SecurityUserID != -1) : allUsers.filter(a => a.CheckerID === 0 && a.SecurityUserID != -1)"
    :search="search"
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New User</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            dense filled
            color="#2A353D"
            prepend-inner-icon="mdi-account"
            v-model="user.UserID"
            label="Username"
            required
            :rules="userNameRules"
          ></v-text-field>

          <v-text-field
            light dense filled
            color="#2A353D"
            prepend-inner-icon="mdi-email"
            v-model="user.Email"
            type="email"
            label="Email"
            required
            :rules="emailRules"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            prepend-inner-icon="mdi-badge-account-horizontal"
            v-model="user.FullName"
            label="Full Name"
            required
            :rules="fullNameRules"
          ></v-text-field>

          <v-text-field
            light dense filled
            color="#2A353D"
            prepend-inner-icon="mdi-phone-classic"
            v-model="user.Mobile"
            label="Mobile"
            :rules="[
              v => v ? (v && v.length <= 20) || 'field must be less than 20 characters' : null
            ]"
          ></v-text-field>

          <v-select
            filled dense
            v-model="user.OfficeId"
            :items="allOffices.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="Name"
            item-value="OfficeId"
            label="Office"
          ></v-select>
        </v-col>
        <v-col>
          <v-checkbox
            v-model="user.UserMustChangePassword"
            class="mt-0"
            disabled
            label="Change password at next Login?"
          ></v-checkbox>

          <v-checkbox
            v-model="user.IsPrimaryOfficer"
            class="mt-0"
            label="User is Primary relationship Officer?"
          ></v-checkbox>

          <v-checkbox
            v-model="user.IsSecondaryOfficer"
            class="mt-0"
            label="User is Secondary relatioship Officer?"
          ></v-checkbox>

          <v-checkbox
            v-model="user.UserIsDisabled"
            class="mt-0"
            label="Account is Disabled?"
          ></v-checkbox>

          <v-checkbox
            v-model="user.AccountIsLockedOut"
            class="mt-0"
            label="Account is Locked?"
          ></v-checkbox>
          <div class="text-right">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
            <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
          </div>   
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Edit User</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            dense filled
            color="#2A353D"
            prepend-inner-icon="mdi-account"
            v-model="activeUser.UserID"
            label="Username"
            required
            :rules="userNameRules"
          ></v-text-field>

          <v-text-field
            light dense filled
            color="#2A353D"
            prepend-inner-icon="mdi-email"
            v-model="activeUser.Email"
            type="email"
            label="Email"
            required
            :rules="emailRules"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            prepend-inner-icon="mdi-badge-account-horizontal"
            v-model="activeUser.FullName"
            label="Full Name"
            required
            :rules="fullNameRules"
          ></v-text-field>

          <v-text-field
            light dense filled
            color="#2A353D"
            prepend-inner-icon="mdi-phone-classic"
            v-model="activeUser.Mobile"
            label="Mobile"
            :rules="[
              v => v ? (v && v.length <= 20) || 'field must be less than 20 characters' : null
            ]"
          ></v-text-field>

          <v-select
            filled dense
            v-model="activeUser.OfficeId"
            :items="allOffices.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="Name"
            item-value="OfficeId"
            label="Office"
          ></v-select>
        </v-col>
        <v-col>
          <v-checkbox
            v-model="activeUser.UserMustChangePassword"
            class="mt-0"
            label="Change password at next Login?"
          ></v-checkbox>

          <v-checkbox
            v-model="activeUser.IsPrimaryOfficer"
            class="mt-0"
            label="User is Primary relationship Officer?"
          ></v-checkbox>

          <v-checkbox
            v-model="activeUser.IsSecondaryOfficer"
            class="mt-0"
            label="User is Secondary relatioship Officer?"
          ></v-checkbox>

          <v-checkbox
            v-model="activeUser.UserIsDisabled"
            class="mt-0"
            label="Account is Disabled?"
          ></v-checkbox>

          <v-checkbox
            v-model="activeUser.AccountIsLockedOut"
            class="mt-0"
            label="Account is Locked?"
          ></v-checkbox>
          <div class="text-right">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="closeEdit()">close</v-btn>
            <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="update()">save</v-btn>
          </div>
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedUsers" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedUsers" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Users.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Users.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-if="confirmedUsers" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedUsers" @click="confirmedUsers = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.avatar="{ item }">
      <v-avatar size="30" color="grey">
        <span class="white--text">{{ item.FullName.substring(0, 1) }}</span>
      </v-avatar>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedUsers && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveUser(item, index); confirm()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-2"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-btn
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveUser(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-2"
      >
        <span>edit</span>
      </v-btn>

      <v-menu rounded-lg offset-y>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="#2A353D" class="mr-3"
                small outlined
                :disabled="item.UserIsDisabled == 1"
                @mouseover="setActiveUser(item, index)"
                v-bind="attrs"
                v-on="{...tooltip,...menu}"
              >
              ROLES  <v-icon small class="ml-1" color="#2A353D">mdi-circle-edit-outline</v-icon>
              </v-btn>
            </template> <span>edit roles</span>
          </v-tooltip>
        </template>

        <v-list dense>
          <v-list-item
            v-for="role in allRoles.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            :key="role.SecurityRoleID"
          >

          <v-list-item-title>
            {{ role.Role }}
          </v-list-item-title>

          <v-list-item-action>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-if="showActiveRole(role)" @click="removeRole(role.SecurityRoleID)" x-small v-on="on" icon color="error">
                  <v-icon>mdi-minus-box</v-icon>
                </v-btn>
                <v-btn v-else @click="addRole(role.SecurityRoleID)" x-small v-on="on" icon color="success">
                  <v-icon>mdi-plus-box</v-icon>
                </v-btn>
              </template>
              <span>add/remove</span>
            </v-tooltip>
          </v-list-item-action>

          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <template v-slot:item.UserIsDisabled="{ item }">
      <v-chip color="error" small outlined v-if="item.UserIsDisabled == 1">disabled</v-chip>
      <v-chip color="success" small outlined v-else>active</v-chip>
    </template>

      <template v-slot:item.AccountIsLockedOut="{ item }">
        <v-tooltip v-if="item.AccountIsLockedOut == 1" top>
          <template v-slot:activator="{ on }">
            <v-icon small v-on="on" color="error">mdi-lock</v-icon>
          </template>
          <span>locked</span>
        </v-tooltip>
        <v-tooltip v-else top>
          <template v-slot:activator="{ on }">                
            <v-icon small v-on="on">mdi-lock-open-variant</v-icon>
          </template>
          <span>unlocked</span>
        </v-tooltip>
      </template>

    <template  v-slot:item.roles="{ item }">
    <span v-if="item.SecurityUserID !== null">
      <v-chip class="ma-1" small v-for="user_role in item.user_role.filter(u => u.Deleted == 0)" :key="user_role">{{user_role.role_name.map(r => r.RoleCode).toLocaleString()}}</v-chip>
    </span>
    </template>

    <!-- <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template> -->

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  name: 'user-management',

  data () {
    return {
      confirmedUsers: true,
      user: {
        UserMustChangePassword: true,
      },
      edit: false,
      create: false,
      dialog: false,
      content: '',
      message: '',
      search: '',
      valid: true,
      successful: false,
      ActiveRole: false,
      permitted: null,
      permitted_dialog: true,
      activeUser: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        { value: 'avatar', sortable: false },
        {
          text: 'Full name',
          align: 'start',
          sortable: true,
          value: 'FullName'
        },
        { text: 'E-mail', value: 'Email', sortable: false },
        { text: 'Status', value: 'UserIsDisabled', sortable: false },
        { text: 'Lock',value: 'AccountIsLockedOut', sortable: false },
        // { text: 'Date created', value: 'MakeDate', sortable: true },
        { text: 'Roles', value: 'roles', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      userNameRules: [
        v => !!v || 'username is required',
        v => (v && v.length <= 50) || 'username must be less than 50 characters',
        v => (v && v.length >= 3) || 'username must be at least 3 characters',
      ],
      fullNameRules: [
        v => !!v || 'Full name is required',
        v => (v && v.length <= 100) || 'field must be less than 100 characters',
        v => (v && v.length >= 3) || 'username must be at least 3 characters',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        v => (v && v.length <= 200) || 'field must be less than 200 characters'
      ],
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allUsers",
      "allRoles",
      "allOffices",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 501).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 501).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 501).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 501).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 501).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createUser",
      "updateUser",
      "addUser_Role",
      "removeUser_Role",
      "changePassword",
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.user.MakerID = this.currentUser.SecurityUserID,
        this.user.CheckerID = this.CheckerID,
        this.user.LastUserID = this.currentUser.SecurityUserID,
        this.user.Authorisers = this.allUsers.filter(a => a.user_role.filter(u => u.Deleted == false).map(u => u.role_name.map(r => r.RoleCode)[0]).includes('BO Auth')).map(a => a.Email),
        this.createUser(this.user)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newUser',
            data: response.data
          });
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.activeUser.MakerID = this.currentUser.SecurityUserID
        this.activeUser.LastUserID = this.currentUser.SecurityUserID,
        this.activeUser.CheckerID = 0,
        this.activeUser.CheckDate = null,
        this.activeUser.MakeDate = new Date(),

        this.updateUser(this.activeUser)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updUser',
            data: this.activeUser
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    confirm() {
      this.message = '';

      this.activeUser.CheckerID = this.currentUser.SecurityUserID,
      this.activeUser.LastUserID = this.currentUser.SecurityUserID,
      this.activeUser.CheckDate = new Date(),
      this.activeUser.updatedAt = new Date(),
      this.activeUser.isConfirm = true,

      this.updateUser(this.activeUser)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updUser',
          data: this.activeUser
        });
        
        this.message = response.data.message
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    addRole(roleId) {
      this.message = '';      
      var data ={
        SecurityUserID: this.activeUser.SecurityUserID,
        SecurityRoleID: roleId,
        MakerID: this.currentUser.SecurityUserID,
        LastUserID: this.currentUser.SecurityUserID
      }

      this.addUser_Role(data)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updUserRole',
          data: response.data
        });
        
        this.message = response.data.message
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    removeRole(roleId) {
      this.message = '';
      var data ={
        SecurityUserID: this.activeUser.SecurityUserID,
        SecurityRoleID: roleId,
        LastUserID: this.currentUser.SecurityUserID
      }

      this.removeUser_Role(data)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updUserRole',
          data: response.data
        });
        
        this.message = response.data.message
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Users", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Users.pdf')
      }
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedUsers = false
    },

    showActiveRole(data) {
      for (let i = 0; i < data.User.length; i++) {
        if (data.User[i].SecurityUserID == this.activeUser.SecurityUserID){
          if (this.activeUser.user_role.filter(u => u.Deleted == 0).map(u => u.SecurityRoleID).includes(data.SecurityRoleID)){
            return true
          }
        }
      }
      return false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.create = false
      this.reset()
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveUser (item, index) {
      this.activeUser = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isUsers().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedUsers", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
